import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: the page itself lives in en.industries.pharma-biotech.index.tsx. Without this wrapper the
// page component would shadow every nested child route.
export const Route = createFileRoute("/en/industries/pharma-biotech")({
  component: RouteLayout,
});

function RouteLayout() {
  return <Outlet />;
}
